import { FC, ReactNode } from 'react';
import { Card } from '@kpa/kul';
import { useNavigate } from 'react-router-dom';
import { ContentResponse } from '../types/shared';
import { HeroknappBlockResponse } from '../types/blocks';

interface IHeroknappBlock {
  contentResponse: ContentResponse;
}

const HeroknappBlock: FC<IHeroknappBlock> = ({ contentResponse }): ReactNode => {
  const nav = useNavigate();
  const heroknappBlockResponse = contentResponse.content as HeroknappBlockResponse;

  const redirect = (url: string) => {
    nav(url);
  };

  return (
    <Card
      title={heroknappBlockResponse.rubrik}
      variant="regularShortcut"
      href={heroknappBlockResponse.url}
      callback={redirect}
      headingLevel={2}
    >
      {heroknappBlockResponse.teasertext}
    </Card>
  );
};

export default HeroknappBlock;
